import EsusView from 'components/esus/EsusView'

export default function SituacaoTerritorioView() {
  return <EsusView url='/pec/user/relatorios/consolidados/situacaoTerritorio' />
}
